import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Icon from '@material-ui/core/Icon';

const Container = styled.div`
  height: auto;
  padding-right: 6px;
`
const IconStyled = styled(Icon)`
  font-size: 12px;
`

const Button = ({
  level,
  levels,
  ...other
}) => {

  level = level || 0;

  const getLevelOrder = () => {
    for (let i = 0; i < levels.length; i++) {
      if (levels[i].level === level) {
        return levels[i].level;
      }
    }

    return 0;
  }

  const levelOrder = getLevelOrder();

  return (
    <Container {...other}>
      {Array(levelOrder).fill().map((item, index) =>
        <IconStyled key={`checked-level-${index}`}>radio_button_checked</IconStyled>
      )}
      {Array(levels.length - levelOrder).fill().map((item, index) =>
        <IconStyled key={`unchecked-level-${index}`}>radio_button_unchecked</IconStyled>
      )}
    </Container>
  )
}

Button.propTypes = {
  level: PropTypes.number,
  levels: PropTypes.array,
};

Button.defaultProps = {
  level: 0,
  levels: [],
};

export default Button;
